var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6923",
    "data-name": "Rect\\xE1ngulo 6923",
    width: 28.868,
    height: 16.89,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Med_Ico",
    "data-name": "Med Ico",
    transform: "translate(0 5.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 36,
    height: 36,
    transform: "translate(0 -5.126)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17500",
    "data-name": "Grupo 17500",
    transform: "translate(3.566 4.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17499",
    "data-name": "Grupo 17499",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19425",
    "data-name": "Trazado 19425",
    d: "M13.654,73.221c2.354-.72,4.506-3.4,6.5-5.455a27.826,27.826,0,0,0-2.275-1.9c-1,1.072-1.889,2.21-2.66,3.073-1.8,2.018-3.76,3.849-4.96,3.094h0a1.658,1.658,0,0,0,.614,1.191h0a4.681,4.681,0,0,0,2.782-.009",
    transform: "translate(-8.911 -57.229)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19426",
    "data-name": "Trazado 19426",
    d: "M28.745,0A2.344,2.344,0,1,1,26.4,2.344,2.344,2.344,0,0,1,28.745,0",
    transform: "translate(-22.938)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19427",
    "data-name": "Trazado 19427",
    d: "M160.292,0a2.344,2.344,0,1,0,2.344,2.344A2.344,2.344,0,0,0,160.292,0",
    transform: "translate(-137.231)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19428",
    "data-name": "Trazado 19428",
    d: "M94.519,0a2.344,2.344,0,1,0,2.344,2.344A2.344,2.344,0,0,0,94.519,0",
    transform: "translate(-80.085)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19429",
    "data-name": "Trazado 19429",
    d: "M110.043,55.327c4.354,0,6.1-11.225,10.459-7.254,1.229,1.12,3.834,4.91,2.014,6.365,4.92-2.239-.363-11.832-5.48-9.956-4.237,1.553-5.137,7.176-6.993,7.176Z",
    transform: "translate(-95.609 -38.438)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19430",
    "data-name": "Trazado 19430",
    d: "M83.512,52.022c-2.765-.846-5.251-4.388-7.526-6.462a3.187,3.187,0,0,0-4.329,0c-.338.308-.681.649-1.028,1.008a27.8,27.8,0,0,0-2.276-1.9c1.582-1.7,3.427-3.227,5.468-3.2,3.328-.044,6.134,4.041,8.128,6.273,1.8,2.018,3.76,3.849,4.96,3.094h0a1.658,1.658,0,0,1-.614,1.191h0a4.681,4.681,0,0,1-2.782-.009",
    transform: "translate(-59.387 -36.03)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19431",
    "data-name": "Trazado 19431",
    d: "M14.433,55.327c-4.354,0-6.1-11.225-10.459-7.254C2.745,49.193.14,52.982,1.96,54.438c-4.92-2.239.363-11.832,5.48-9.956,4.237,1.553,5.137,7.176,6.993,7.176Z",
    transform: "translate(0.001 -38.438)",
    fill: "#f1f2f2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.cb02420403c097537032b6da9a738a32.svg";
export { ForwardRef as ReactComponent };